module.exports = __webpack_public_path__ + "media/images/client-8-eb784b210f97acb0b2a272bebad81a45.png";